import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { PARAGRAPH_TOGGLE } from '../../plugins-common/ParagraphToggle/types';
import {
  EXERCISE_SHORT_ANSWER,
  EXERCISE_SHORT_ANSWER_BLANK,
  EXERCISE_SHORT_ANSWER_QUESTION,
  EXERCISE_SHORT_ANSWER_QUESTIONS,
} from './types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const DoTestExerciseShortAnswer = dynamicEditorComponent(() =>
  import('./components/readonly/DoTestExerciseShortAnswer').then(
    (mod) => mod.DoTestExerciseShortAnswer
  )
);

const DoTestQuestion = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () => import('./components/readonly/DoTestQuestion').then((mod) => mod.DoTestQuestion),
    {
      dependsOn: DoTestExerciseShortAnswer,
    }
  )
);
const DoTestExerciseShortAnswerQuestions = withDynamicBlogEditorPluginHydration({
  canInteract: true,
})(
  dynamicEditorComponent(
    () =>
      import('./components/readonly/DoTestExerciseShortAnswerQuestions').then(
        (mod) => mod.DoTestExerciseShortAnswerQuestions
      ),
    {
      dependsOn: DoTestExerciseShortAnswer,
    }
  )
);
const ParagraphToggleOverrided = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () =>
      import('./components/readonly/ParagraphToggleOverrided').then(
        (mod) => mod.ParagraphToggleOverrided
      ),
    {
      dependsOn: DoTestExerciseShortAnswer,
    }
  )
);
const ShortAnswerInput = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () => import('./components/readonly/ShortAnswerInput').then((mod) => mod.ShortAnswerInput),
    {
      dependsOn: DoTestExerciseShortAnswer,
    }
  )
);

export const renderReadOnlyElementExerciseShortAnswer = (options) => (props) => {
  const { onBackWhenInComplete } = options;
  const { element } = props;

  switch (element.type) {
    case PARAGRAPH_TOGGLE: {
      if (element.parentNodeType !== EXERCISE_SHORT_ANSWER) return undefined;
      return <ParagraphToggleOverrided {...props} />;
    }

    case EXERCISE_SHORT_ANSWER:
      return <DoTestExerciseShortAnswer {...props} onBackWhenInComplete={onBackWhenInComplete} />;

    case EXERCISE_SHORT_ANSWER_QUESTIONS:
      return <DoTestExerciseShortAnswerQuestions {...props} />;

    case EXERCISE_SHORT_ANSWER_QUESTION:
      return <DoTestQuestion {...props} />;

    case EXERCISE_SHORT_ANSWER_BLANK:
      return <ShortAnswerInput {...props} />;

    default:
      return undefined;
  }
};
